import type { Driver } from 'api/quote-marketplace';

export { SALUTATIONS } from './personOptions';

export const SUFFIXES = [
  { value: '', label: '' },
  { value: 'Jr', label: 'Jr.' },
  { value: 'Sr', label: 'Sr.' },
  { value: 'II', label: 'II' },
  { value: 'III', label: 'III' },
  { value: 'IV', label: 'IV' },
];

export const CLAIM_STATUSES = [
  { value: '', label: 'Select...' },
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'pending', label: 'Pending' },
];

export const FAULT_PERCENTAGES = [
  { value: 0, label: '0% (Not at fault)' },
  { value: 25, label: '25%' },
  { value: 50, label: '50%' },
  { value: 75, label: '75%' },
  { value: 100, label: '100% (Fully at fault)' },
];

export const createEmptyDriver = (id: number = 1): Driver => ({
  id,
  excluded: false,
  dash_driver_index: null,
  personal_info: {
    salutation: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    suffix: '',
    license_number: '',
    applicant_gender: '',
    marital_status: '',
    relation_to_applicant: '',
    lives_with_parents: false,
  },
  licensing: {
    date_of_birth: null,
    age: null,
    out_of_province_country: false,
    drivers_training: false,
    training_completion_date: null,
    other_license_details: {
      motorcycle: false,
      motorcycle_class: null,
      commercial: false,
      commercial_class: null,
      physical_impairment: false,
    },
  },
  insurance_details: {
    has_prior_insurance: null,
    continuously_insured_date: null,
    continuously_insured_years: null,
    company_insured_date: null,
    renewal_carriers: [],
    current_insurer: '',
    brokerage_insured_date: null,
    owner_principal_date: null,
    grid_level: null,
    grid_level_relevant_date: null,
  },
  occupation: {
    occupation: '',
    occupation_other: '',
    student_away_at_school: false,
    student_away_km: null,
    retired: false,
    good_student_discount: false,
  },
  memberships: [],
  incidents: {
    claims: [],
    convictions: [],
    suspensions: [],
    lapses: [],
    fraud_misrepresentation: [],
  },
});

export const createEmptyAutoClaim = (id: number = 1) => ({
  id,
  source: 'manual' as const,
  date: null as string | null,
  type_code: null as string | null,
  cause_code: null as string | null,
  item_id: null as number | null,
  item_description: '',
  cover_types: [] as string[],
  fault_percentage: 0,
  payout_collision: null as number | null,
  payout_accident_benefits: null as number | null,
  payout_liability_bodily_injury: null as number | null,
  payout_liability_property_damage: null as number | null,
  payout_other_pd: null as number | null,
  dash_coverage: null as string | null,
  status: '',
});

export const createEmptyConviction = (id: number = 1) => ({
  id,
  source: 'manual' as const,
  date: null as string | null,
  conviction_code: null as string | null,
  conviction_code_other: null as string | null,
  speed_over_limit_kmh: null as number | null,
});

export const createEmptySuspension = (id: number = 1) => ({
  id,
  source: 'manual' as const,
  start_date: null as string | null,
  end_date: null as string | null,
  reason: '',
  reason_code: null as string | null,
  reason_other: null as string | null,
});

export const createEmptyLapse = (id: number = 1) => ({
  id,
  source: 'manual' as const,
  reason: '',
  reason_code: null as string | null,
  reason_other: null as string | null,
  lapse_date: null as string | null,
  reinstatement_date: null as string | null,
  duration_months: null as number | null,
});

export const createEmptyFraudMisrepresentation = (id: number = 1) => ({
  id,
  source: 'manual' as const,
  date: null as string | null,
  reason_code: null as string | null,
  reason_other: null as string | null,
  policy_status_code: null as string | null,
});

export const createEmptyMembership = () => ({
  membership_group: '',
  member_number: '',
  member_date: null as string | null,
});
